import { useQuery } from '@tanstack/react-query';
import { Select } from 'antd';
import { ReactNode, useEffect, useState } from 'react';
import { getDepartmentsDropdown } from 'src/apis/master_data/department.api';
import { TreeItem } from '@martech-solution/utils/types';
import { buildHierarchySelect } from 'src/utils/collection';

interface Props {
  value?: React.SetStateAction<number | undefined>;
  style?: React.CSSProperties | undefined;
  allowClear?: boolean | undefined;
  onChange?: (value: React.SetStateAction<number | undefined>) => void;
  disabled?: boolean;
  placeholder?: ReactNode;
}

export default function DepartmentSelect({ value, style, allowClear, onChange, disabled, placeholder }: Props) {
  const [departmentTreeItem, setDepartmentTreeItem] = useState<TreeItem[] | undefined>(undefined);

  const departmentsDropdownQuery = useQuery({
    queryKey: ['departmentsDropdown'],
    queryFn: () => getDepartmentsDropdown(),
    staleTime: 5 * 60 * 1000
  });

  useEffect(() => {
    const result = buildHierarchySelect(departmentsDropdownQuery.data?.data);
    setDepartmentTreeItem(result);
  }, [departmentsDropdownQuery.data?.data]);

  return (
    <Select
      allowClear={allowClear}
      value={departmentsDropdownQuery.isFetching ? undefined : value}
      style={style}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder}
      options={departmentTreeItem?.map((data) => ({
        value: Number(data.value),
        label: data.title
      }))}
      showSearch
      filterOption={(input, option) => (option?.label?.toString() ?? '').toLowerCase()?.includes(input.toLowerCase())}
      loading={departmentsDropdownQuery.isFetching}
    />
  );
}
